export default __webpack_public_path__ + "static/media/seven.fd747c84.jpeg";